(() => {
  const SELECTOR = '[data-return-service]';

  const initReturnService = (container) => {
    if (!container || container.dataset.returnServiceInitialized === 'true') return;
    container.dataset.returnServiceInitialized = 'true';

    const items = container.querySelectorAll('.return-service__item');

    const toggleItem = (item) => {
      const content = item.querySelector('.return-service__item-content');
      const arrow = item.querySelector('[data-return-service-arrow]');
      if (!content) return;

      const willOpen = !content.classList.contains('open');
      content.classList.toggle('open', willOpen);
      arrow?.classList.toggle('open', willOpen);

      if (willOpen) {
        content.style.height = `${content.scrollHeight + 1}px`;
      } else {
        content.style.height = '0px';
      }
    };

    const syncOpenHeights = () => {
      items.forEach((item) => {
        const content = item.querySelector('.return-service__item-content');
        if (content?.classList.contains('open')) {
          content.style.height = `${content.scrollHeight + 1}px`;
        }
      });
    };

    items.forEach((item) => {
      item.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;
        toggleItem(item);
      });
    });

    window.addEventListener('resize', syncOpenHeights);
  };

  const bootstrap = () => {
    document.querySelectorAll(SELECTOR).forEach(initReturnService);
  };

  document.addEventListener('DOMContentLoaded', bootstrap);
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target?.querySelector?.(SELECTOR);
    if (container) initReturnService(container);
  });
  document.addEventListener('shopify:section:select', (event) => {
    const container = event.target?.querySelector?.(SELECTOR);
    if (container) initReturnService(container);
  });
})();
